import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/redux';

interface UnprotectedRouteProps {
  children: React.ReactNode;
}

const UnprotectedRoute: React.FC<UnprotectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    console.log('[UnprotectedRoute] isAuthenticated:', isAuthenticated);
  }, [isAuthenticated]);

  if (isAuthenticated) {
    console.log('[UnprotectedRoute] User is authenticated, redirecting to conversation');
    return <Navigate to="/conversation" replace />;
  }

  return <>{children}</>;
};

export default UnprotectedRoute;